import { t } from '@/features/i18n/utils';
import { UnreadIndicator } from '@/features/comments/components/unread-indicator';
import { GlobalSearch } from '@/features/search/components/global-search';
import { ChatAnnouncementCard } from '@/features/chat/components/chat-announcement-card';
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarHelpButton,
  SidebarItem,
  SidebarLink,
  SidebarList,
  SidebarLogo,
  SidebarReleaseNotes,
  SidebarTrigger,
  SidebarUserMenu,
} from '@/ui/components/sidebar';
import { Icon } from '@/ui/components/icon';
import {
  Building06Icon,
  InboxIcon,
  SettingsIcon,
  SparklesIcon,
  SquareCheckBigIcon,
} from '@hugeicons-pro/core-stroke-rounded';
import { unreadCountQuery } from '@/features/notifications/queries';
import { useQuery } from '@tanstack/react-query';
import { FavoritesList } from '@/features/favorites/components/favorites-list';
import { RecentWorkspaces } from '@/features/workspaces/components/recent-workspaces';

export function OrganizationSidebar() {
  const { data: unreadData } = useQuery(unreadCountQuery());
  const hasUnread = (unreadData?.unreadCount ?? 0) > 0;

  return (
    <Sidebar>
      <SidebarContent>
        <SidebarHeader>
          <SidebarLogo />
          <GlobalSearch />
          <SidebarTrigger />
        </SidebarHeader>
        <SidebarList>
          <SidebarItem>
            <SidebarLink to={'/'}>
              <Icon icon={Building06Icon} />
              {t({ en: 'Projects', nb: 'Prosjekter' })}
            </SidebarLink>
          </SidebarItem>
          <SidebarItem>
            <SidebarLink to={'/notifications'} className="relative">
              <Icon icon={InboxIcon} />
              {hasUnread && <UnreadIndicator className="absolute top-1 left-4.5" />}
              {t({ en: 'Notifications', nb: 'Notifikasjoner' })}
            </SidebarLink>
          </SidebarItem>
          <SidebarItem>
            <SidebarLink to={'/my-tasks'}>
              <Icon icon={SquareCheckBigIcon} />
              {t({ en: 'My tasks', nb: 'Mine oppgaver' })}
            </SidebarLink>
          </SidebarItem>
          <SidebarItem>
            <SidebarLink to={'/learnings'}>
              <Icon icon={SparklesIcon} />
              {t({ en: 'Learnings', nb: 'Erfaringer' })}
            </SidebarLink>
          </SidebarItem>
          <SidebarItem>
            <SidebarLink to={'/settings/profile'}>
              <Icon icon={SettingsIcon} />
              {t({ en: 'Settings', nb: 'Innstillinger' })}
            </SidebarLink>
          </SidebarItem>
        </SidebarList>
        <RecentWorkspaces />
        <FavoritesList />
        <div className="mt-auto space-y-3">
          <ChatAnnouncementCard />
          <SidebarList>
            <SidebarHelpButton />
            <SidebarReleaseNotes />
          </SidebarList>
          <SidebarUserMenu />
        </div>
      </SidebarContent>
    </Sidebar>
  );
}
